import React, {useRef} from "react";
import {Button} from "@blueprintjs/core";
import ConfigurationDialogV2, {ConfigurationDialogRef} from "./ManifestCardConfigurationDialog";
import {GearIcon} from "../../../common/icons";

const ManifestCardConfiguration = () => {
  const dialogRef = useRef<ConfigurationDialogRef>(null);
  const handleOpenDialog = () => {
    dialogRef.current?.onOpenDialog();
  };
  return (
    <>
      <Button
        onClick={handleOpenDialog}
        endIcon={<GearIcon />}
        variant="minimal"
        data-testid="manifest-configuration-button"
      />
      <ConfigurationDialogV2 ref={dialogRef} />
    </>
  );
};

export default ManifestCardConfiguration;
